import { useEffect } from "react"
import { connect } from "react-redux"
import { requestPermissions, requestUser } from "src/engine/modules/currentUser"

// Простейший способ задиспатчить экшены на загрузку полномочий при старте приложения
export default connect(null, {
  requestPermissions,
  requestUser,
})(({ requestPermissions, requestUser }) => {
  useEffect(() => {
    requestPermissions()
    requestUser()
  }, [])

  return null
})
